var map = {
	"./TE.js": "5abm",
	"./agent.js": "JHZa",
	"./index.js": "YaEn",
	"./login.js": "QNKx",
	"./room.js": "vDo+",
	"./testing.js": "tmWP",
	"./trtc.js": "NusZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RiIY";


//////////////////
// WEBPACK FOOTER
// ./src/router nonrecursive \.js$
// module id = RiIY
// module chunks = 8